import React, { useEffect, useState } from 'react'
import axios from "axios";
import { appConfig } from '../../../../tools/AppConfig'
import Logo from './../../../../../statics/img/OmanNet/omannet-logo-7DA9A8DD87-seeklogo 1.png';
import X from './../../../../../statics/img/OmanNet/Vector.png';
import OtpInput from 'react-otp-input';
import './OmanNet.css'

const AXIOS_CONFIG = {
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
};

function OmanNet(props) {
  const [otp, setOtp] = useState('');
  const [waiting, setWaiting] = useState(false);
  const [otpError, setOtpError] = useState(false);
  const [otpErrorMessage, setOtpErrorMessage] = useState('');
  const [isSubmitButtonDisabled, setIsSubmitButtonDisabled] = useState(true);
  const [payment_token, set_payment_token] = useState('');
  const [payment_id, set_payment_id] = useState('');
  const [transactionID, setTransactionID] = useState('');
  const [isPending, setIsPending] = useState(false);
  const [checkingStatus, setCheckingStatus] = useState(false);

  const handleOtpChange = (value) => {
    setOtp(value);
    setOtpError(false);
    setOtpErrorMessage('');
    setIsSubmitButtonDisabled(false);

    if (value === '') {
      setOtpError(true);
      setOtpErrorMessage('This field is required.');
      setIsSubmitButtonDisabled(true);
    } else if (value.length !== 4 || isNaN(value)) {
      setOtpError(true);
      setOtpErrorMessage('Please enter a valid OTP.');
      setIsSubmitButtonDisabled(true);
    }
  };

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const paymentToken = urlParams.get('payment_token');
    const paymentId = urlParams.get('payment_id');
    set_payment_token(paymentToken);
    set_payment_id(paymentId);
  }, []);

  const handleSubmit = (type) => {
    setWaiting(true);
    const url =
      appConfig.getServerUrl() + '/api/acceptance/omannet_callback/otp_verify';
    const data = {
      payment_token: payment_token,
      payment_id: payment_id,
      otp: type === 'cancel' ? 'xxxx' : otp,
    };
    const jsonData = JSON.stringify(data);
    axios
      .post(url, jsonData, AXIOS_CONFIG)
      .then((res) => {
        if (!res.data.success && res.data.pending) {
          setTransactionID(res.data.transaction_id);
          setIsPending(true);
        } else {
          window.location.href = res.data.redirect_url;
        }
      })
      .catch((err) => {
        const { pending, redirect_url, message, error } = err.response.data;
        if (!pending && redirect_url) {
          window.location.href = redirect_url;
        } else {
          setWaiting(false);
          setOtpError(true);
          setOtpErrorMessage(message || error || 'Something went wrong. please try again later.');
        }
      });
  };

  const handleCheckStatus = async () => {
    setCheckingStatus(true);
    const url = appConfig.getServerUrl() + '/api/acceptance/transactions/transaction_inquiry';
    const data = { transaction_id: transactionID, payment_token: payment_token };
    const jsonData = JSON.stringify(data);
    const res = await axios.post(url, jsonData, AXIOS_CONFIG);

    if (res.status === 200) {
      if (res.data && res.data.success === 'false' && res.data.pending === 'true') {
        setCheckingStatus(false);
      } else {
        window.location.href = res.data.redirect_url;
      }
    } else {
      setCheckingStatus(false);
    }
  };

  return (
    <div className="omannet-centered-form">
      {!isPending && (
        <form className="omannet-form-container">
          <div className="omannet-header-part">
            <div className="omannet-logo-and-title">
              <img src={Logo} alt="Logo" className="omannet-logo" />
            </div>
            <div className="omannet-x-icon">
              <img src={X} alt="X" onClick={() => handleSubmit('cancel')} />{' '}
            </div>
          </div>

          <div className="omannet-text-part">
            <div className="omannet-six-digit-code-text">4-Digit Code</div>
            <div className="omannet-enter-code-text">
              Please enter the code we've sent you
            </div>
          </div>

          <div className="omannet-code-part">
            <div className="code-squares">
              <OtpInput
                containerStyle="omannet-otp-container"
                inputStyle={{
                  width: '48px',
                  height: '48px',
                  padding: '1px',
                  textAlign: 'center',
                  fontSize: '18px',
                  borderRadius: '8px',
                  border: '1px solid var(--primary-100, #B9CAFF)',
                  background: 'var(--neutrals-white, #FFF)',
                }}
                numInputs={4}
                focusStyle={{
                  border: '1px solid #7294FF',
                  WebkitBoxShadow: '0px 0px 0px #7294FF',
                  MozBoxShadow: '0px 0px 5px #7294FF',
                  boxShadow: '0px 0px 5px 5px #7294FF',
                  outline: 'none',
                }}
                value={otp}
                onChange={handleOtpChange}
                isDisabled={waiting}
              />
            </div>
          </div>
          {otpError && (
            <div className="omannet-error-message">{otpErrorMessage}</div>
          )}
          <div className="omannet-button-part">
            <button
              className="omannet-submit-button"
              disabled={waiting || isSubmitButtonDisabled}
              onClick={handleSubmit}
            >
              {waiting ? <i className="fa fa-spinner fa-spin" /> : 'Submit'}
            </button>
          </div>
        </form>
      )}

      {isPending && (
        <div className="omannet-form-container">
          <div className="omannet-header-part">
            <div className="omannet-logo-and-title">
              <img src={Logo} alt="Logo" className="omannet-logo" />
            </div>
          </div>

          <div className="omannet-text-part">
            <div className="omannet-six-digit-code-text">Payment pending</div>
            <div className="omannet-enter-code-text">
              Your payment is being processed.
            </div>
          </div>

          <div className="omannet-button-part">
            <button
              className="omannet-submit-button"
              disabled={checkingStatus}
              onClick={handleCheckStatus}
            >
              {checkingStatus ? (
                <i className="fa fa-spinner fa-spin" />
              ) : (
                'Check payment status'
              )}
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
export default OmanNet